import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./lotteryFlow.sass";

import { Player } from "@lottiefiles/react-lottie-player";
import animationData from "../../../assets/images/lottery/lottery.json";
import moment from "moment";
import PropTypes from "prop-types";

export default function LotteryFlow({
  children,
  userName,
  completionDate,
  courseName,
  equipmentName,
  clickUnlockHandler,
  clickConfirmHandler,
}) {
  const { t } = useTranslation();
  const [lottieInstance, setLottieInstance] = useState(null);
  const [progress, setProgress] = useState(0);
  const [isComplete, setIsComplete] = useState(false);
  const handleLottieRef = (instance) => {
    setLottieInstance(instance);
  };
  const playAnimationHandler = () => {
    lottieInstance.play();
  };
  const getProgressHandler = () => {
    setProgress(lottieInstance.currentFrame / lottieInstance.totalFrames);
    if (lottieInstance.currentFrame > 37) {
      setIsComplete(true);
    }
  };
  useEffect(() => {
    if (lottieInstance && isComplete) {
      lottieInstance.goToAndStop(lottieInstance.totalFrames - 1, true);
    }
  }, [lottieInstance, isComplete]);

  return (
    <div className={`lottery${isComplete ? " unlock" : ""}`}>
      <div className="lottery-step1">
        <div className="lottery-head">
          <div>
            Hi, {userName}
            <br />
            {t("lottery.content", {
              date: moment(completionDate).format("YYYY/MM/DD"),
              course: courseName,
            })}
            <br />
            {t("lottery.guide")}
          </div>
        </div>
        <div className="lottery-card">
          <div className="card">
            <div className="card-main"></div>
            <button
              className="card-lock"
              onClick={() => {
                playAnimationHandler();
                clickUnlockHandler();
              }}
              style={{ opacity: 1 - progress }}
            ></button>
          </div>
        </div>
      </div>
      <div className="lottery-step2">
        <div className="lottery-title">
          {t("lottery.get")} {equipmentName}！
        </div>
        <div className="lottery-items">{children}</div>
        <div className="lottery-action">
          <button onClick={clickConfirmHandler}>{t("lottery.check")}</button>
        </div>
      </div>
      <div className="lottery-cutscene">
        <Player
          src={animationData}
          style={{
            width: "100%",
            height: "110%",
          }}
          lottieRef={handleLottieRef}
          rendererSettings={{
            preserveAspectRatio: "xMidYMid slice",
          }}
          onEvent={(event) => {
            if (event === "frame") getProgressHandler();
          }}
        ></Player>
      </div>
    </div>
  );
}

LotteryFlow.propTypes = {
  children: PropTypes.node.isRequired,
  userName: PropTypes.string.isRequired,
  completionDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date),
  ]).isRequired,
  courseName: PropTypes.string.isRequired,
  equipmentName: PropTypes.string.isRequired,
  clickUnlockHandler: PropTypes.func.isRequired,
  clickConfirmHandler: PropTypes.func.isRequired,
};
